import React, { forwardRef } from "react";
import "./controls.css";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "outlined" | "text" | "danger";
  size?: "small" | "medium";
  startIcon?: React.ReactNode;
}

/** Shared action control; never submits a form unless explicitly requested. */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button({ variant = "outlined", size = "medium", type = "button", startIcon, children, className = "", ...props }, ref) {
  return <button ref={ref} type={type} className={`navo-button navo-button--${variant} navo-button--${size} ${className}`} {...props}>
    {startIcon && <span className="navo-button__icon" aria-hidden="true">{startIcon}</span>}{children}
  </button>;
});
export default Button;
